module.exports = __webpack_public_path__ + "static/media/Bulk Force Close Import Consignments.989b4a60.csv";